<template>
  <div>
    <div class="is-flex is-align-items-center margin_bottom_0">
      <p><b>{{group_name}}</b></p>
      <div style="width: 6px;"></div>
      <a @click="deleteAll()" class="button is-danger" :class="{ 'is-loading': is_loading }">X</a>
    </div>
    <div class="is-flex is-align-items-center is-flex-wrap-wrap">
      <position-skill v-for="position_skill in position_skills"
                     :key="position_skill.id"
                     :position_skill="position_skill"
                     :position_id="position_id"
                     :company_id="company_id"
                     @refresh="refresh">
      </position-skill>
    </div>
  </div>
</template>
<script>
import PositionSkill from '@/components/PositionSkill'
export default {
  name: 'position-skill-group',
  props: ['group_name', 'position_skills', 'position_id', 'company_id'],
  data () {
    return {
      is_loading: false
    }
  },
  methods: {
    deleteAll () {
      this.is_loading = true
      let requests = []
      for (let i = 0; i < this.position_skills.length; i++) {
        requests.push(this.$network_utils.deletePositionSkill({ id: this.position_skills[i].id, position_id: this.position_id, current_company_id: this.company_id }))
      }
      this.$caller.axios.all(requests).then(() => {
        this.refresh()
        this.is_loading = false
      })
    },
    refresh () {
      this.$emit('refresh')
    }
  },
  components: {
    PositionSkill
  }
}
</script>
